// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"b1c20cc2","container":"b85440a3","recordName":"dac77de6"};